{
  "title": "Game settings",
  "lead": "What a new web player starts with: the game's own defaults, and the ones you change here. A player's own choices always win.",
  "sections": {
    "display": "Display",
    "content": "Content",
    "graphics": "Graphics",
    "audio": "Audio",
    "game": "Game",
    "hud": "HUD",
    "accessibility": "Accessibility",
    "input": "Controls"
  },
  "webSection": "Rows marked Web reach the browser game today.",
  "notWebSection": "Stored now; the browser game will apply them once the web bridge carries this section.",
  "web": "Web",
  "on": "On",
  "off": "Off",
  "gameDefault": "Changed · game default: {{value}}",
  "isDefault": "Game default",
  "reset": "Reset",
  "overrides_one": "{{count}} setting changed",
  "overrides_other": "{{count}} settings changed",
  "lastSaved": "saved {{at}}",
  "discard": "Discard changes",
  "resetAll": "Back to the game's defaults",
  "confirmResetAll": "Put every setting back to the game's default? (Save to apply.)",
  "save": "Save",
  "saved": "Saved: new web players get these settings."
}
